export default "__VITE_ASSET__JWfTgE4T__"